// Lineicons Pro (licensed). Only the icons the panel uses; regenerate with the
// lineicons-pro skill instead of editing paths by hand.
// Names: inbox, user-multiple-4, gear-1, send-2, chevron-left, info-circle,
// search-1, check, minus, book-open, paperclip-1 (stroke) and whatsapp (outlined).

/** Lineicons `inbox` (stroke). */
export function InboxIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M3.375 12.25L5.32047 5.22468C5.50042 4.57488 6.09181 4.125 6.76607 4.125H17.2339C17.9082 4.125 18.4996 4.57488 18.6795 5.22468L20.625 12.25V18.375C20.625 19.2034 19.9534 19.875 19.125 19.875H4.875C4.04657 19.875 3.375 19.2034 3.375 18.375V12.25ZM20.625 12.25H17.0949C16.4426 12.25 15.8651 12.6716 15.6663 13.2928L15.3337 14.3322C15.1349 14.9534 14.5574 15.375 13.9051 15.375H10.0949C9.44263 15.375 8.8651 14.9534 8.66629 14.3322L8.33371 13.2928C8.1349 12.6716 7.55737 12.25 6.90507 12.25H3.375"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `user-multiple-4` (stroke). */
export function ContactsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M14.8985 19.1487C14.8985 19.1487 15.0017 13.205 8.74983 13.205C2.49801 13.205 2.60118 19.1487 2.60118 19.1487M14.1072 5.10514C14.4732 4.94215 14.8785 4.85156 15.3049 4.85156C16.9325 4.85156 18.2519 6.17095 18.2519 7.79851C18.2519 9.42606 16.9325 10.7455 15.3049 10.7455C14.8802 10.7455 14.4765 10.6556 14.1118 10.4939M15.7928 13.2205C21.4958 13.5543 21.3987 19.1487 21.3987 19.1487M11.7517 7.79855C11.7517 9.4261 10.4323 10.7455 8.80475 10.7455C7.17719 10.7455 5.8578 9.4261 5.8578 7.79855C5.8578 6.171 7.17719 4.8516 8.80475 4.8516C10.4323 4.8516 11.7517 6.171 11.7517 7.79855Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `gear-1` (stroke). */
export function SettingsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6.77577 5.51906C6.0659 5.10922 5.15808 5.35238 4.74824 6.06225L3.23225 8.68803C2.8225 9.39774 3.06567 10.3052 3.77537 10.715C4.76459 11.2861 4.7646 12.7139 3.77538 13.285C3.06568 13.6948 2.82252 14.6023 3.23227 15.312L4.74827 17.9378C5.15811 18.6476 6.06592 18.8908 6.77579 18.481C7.76511 17.9098 9.00194 18.6237 9.00194 19.766C9.00194 20.5856 9.66634 21.25 10.4859 21.25H13.5183C14.3377 21.25 15.0019 20.5856 15.0019 19.7663C15.0019 18.6243 16.2381 17.9104 17.2271 18.4813C17.9366 18.891 18.8439 18.6479 19.2535 17.9384L20.7699 15.3119C21.1796 14.6022 20.9365 13.6948 20.2268 13.285C19.2376 12.7139 19.2376 11.2861 20.2268 10.715C20.9365 10.3053 21.1797 9.39779 20.7699 8.6881L19.2536 6.06167C18.8439 5.35214 17.9366 5.10904 17.2271 5.51869C16.2381 6.08967 15.0019 5.37573 15.0019 4.23377C15.0019 3.41437 14.3377 2.75 13.5183 2.75L10.4859 2.75C9.66634 2.75 9.00194 3.41441 9.00194 4.23399C9.00194 5.37637 7.7651 6.09025 6.77577 5.51906Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.086 11.9999C15.086 13.7037 13.7048 15.0849 12.001 15.0849C10.2972 15.0849 8.91602 13.7037 8.91602 11.9999C8.91602 10.2961 10.2972 8.91493 12.001 8.91493C13.7048 8.91493 15.086 10.2961 15.086 11.9999Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `send-2` (stroke). */
export function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5.89629 11.9967H21.5636M5.20266 3.41684L20.6974 10.6408C21.8523 11.1792 21.8523 12.8213 20.6974 13.3598L5.20266 20.5837C3.955 21.1654 2.64828 19.8998 3.18973 18.6342L5.7754 12.5903C5.9366 12.2135 5.9366 11.7871 5.7754 11.4103L3.18973 5.36634C2.64828 4.10071 3.955 2.83516 5.20266 3.41684Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `chevron-left` (stroke). */
export function BackIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M14.375 5.75L8.125 12L14.375 18.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `info-circle` (stroke). */
export function InfoIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 8.66992H12.0007"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 11.2148V15.4392M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `search-1` (stroke). */
export function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M17.2587 17.2593L21.2488 21.2494M19.75 11.2486C19.75 15.9419 15.9444 19.7465 11.25 19.7465C6.55558 19.7465 2.75 15.9419 2.75 11.2486C2.75 6.55528 6.55558 2.75061 11.25 2.75061C15.9444 2.75061 19.75 6.55528 19.75 11.2486Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `check` (stroke). */
export function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M18.75 7.29199L9.33315 16.7088L5.25 12.6257"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `minus` (stroke). */
export function MinusIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 12H18.0007" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Lineicons `stopwatch` (stroke). */
export function StopwatchIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M11.9985 13.2507V8.49455M10.4991 2.75H13.4991M17.6549 7.59451L19.5014 5.74805M19.998 13.2509C19.998 17.6687 16.4167 21.25 11.999 21.25C7.58128 21.25 4 17.6687 4 13.2509C4 8.83321 7.58128 5.25193 11.999 5.25193C16.4167 5.25193 19.998 8.83321 19.998 13.2509Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `sparkle-1` (stroke). */
export function SparkleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M2.75 14.1884C6.09244 14.1884 8.80202 11.4788 8.80202 8.13634C8.80202 11.4788 11.5116 14.1884 14.854 14.1884C11.5116 14.1884 8.80202 16.8979 8.80202 20.2404C8.80202 16.8979 6.09244 14.1884 2.75 14.1884Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13.097 6.28596C14.8428 6.28596 16.258 4.87075 16.258 3.125C16.258 4.87075 17.6732 6.28596 19.419 6.28596C17.6732 6.28596 16.258 7.70117 16.258 9.44692C16.258 7.70117 14.8428 6.28596 13.097 6.28596Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M16.1574 19.0625C17.1584 19.0625 17.9699 18.251 17.9699 17.25C17.9699 18.251 18.7814 19.0625 19.7824 19.0625C18.7814 19.0625 17.9699 19.874 17.9699 20.875C17.9699 19.874 17.1584 19.0625 16.1574 19.0625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `chevron-down` (stroke). */
export function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5.75 9.625L12 15.875L18.25 9.625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `package` (stroke). */
export function ProductsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7.99999 4H6.24999C5.42156 4 4.74999 4.67157 4.74999 5.5V8.9244C4.74999 9.29496 4.61282 9.65241 4.36493 9.92784L2.80102 11.6655C2.62988 11.8557 2.62988 12.1443 2.80102 12.3345L4.36493 14.0722C4.61282 14.3476 4.74999 14.705 4.74999 15.0756V18.5C4.74999 19.3284 5.42156 20 6.24999 20H7.99999M16 20H17.75C18.5784 20 19.25 19.3284 19.25 18.5V15.0756C19.25 14.705 19.3872 14.3476 19.635 14.0722L21.199 12.3345C21.3701 12.1443 21.3701 11.8557 21.199 11.6655L19.635 9.92784C19.3872 9.65241 19.25 9.29496 19.25 8.9244V5.5C19.25 4.67157 18.5784 4 17.75 4H16M11.9998 16.625V11.5055M16.1905 9.50057C16.1176 9.38657 16.0143 9.29182 15.8885 9.22894L12.342 7.45572C12.1267 7.34809 11.8734 7.34809 11.6581 7.45572L8.11154 9.22894C7.98578 9.29182 7.88251 9.38657 7.80953 9.50057C7.73218 9.62139 7.68886 9.76383 7.68886 9.91285V14.0872C7.68886 14.3768 7.85249 14.6415 8.11154 14.7711L11.6581 16.5443C11.7657 16.5981 11.8827 16.625 11.9998 16.625C12.117 16.625 12.2343 16.5981 12.342 16.5443L15.8885 14.7711C16.1476 14.6415 16.3112 14.3768 16.3112 14.0872V9.91285C16.3112 9.76383 16.2679 9.62139 16.1905 9.50057ZM11.9998 11.5055C12.117 11.5055 12.2343 11.4786 12.342 11.4248L16.1905 9.50057M11.9998 11.5055C11.9997 11.5055 11.9999 11.5055 11.9998 11.5055ZM11.9998 11.5055C11.8827 11.5055 11.7657 11.4786 11.6581 11.4248L7.80953 9.50057"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `book-open` (stroke). */
export function KnowledgeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 6.87923C12 6.87923 12.8109 5.70844 14.5625 5.00423C15.7611 4.52236 18.625 4.62923 18.625 4.62923V7.44391M12 6.87923C12 6.87923 11.1891 5.70844 9.4375 5.00423C8.23891 4.52236 5.375 4.62923 5.375 4.62923V7.44391M12 6.87923L12 18.6426M18.625 7.44391V15.641C18.625 15.641 16.5111 15.5341 15.3125 16.016C13.5609 16.7202 12 18.641 12 18.641C12 18.641 10.4391 16.7202 8.6875 16.016C7.48891 15.5341 5.375 15.641 5.375 15.641V7.44391M18.625 7.44391C19.4167 7.3641 20.2791 7.34016 21.25 7.38053V18.6305C18.0823 17.7782 15.1677 17.7782 12 19.3805C8.83227 17.7782 5.91773 17.7782 2.75 18.6305V7.38053C3.72085 7.34016 4.58327 7.3641 5.375 7.44391"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `paperclip-1` (stroke). */
export function AttachIcon() {
  return (
    <svg viewBox="0 0 24 25" fill="none" aria-hidden="true">
      <path
        d="M14.0778 6.65388V16.2692C14.0778 17.4162 13.148 18.3461 12.0009 18.3461C10.8538 18.3461 9.92397 17.4162 9.92397 16.2692V8.15388M14.0778 6.65388L14.0773 14.9422M14.0778 6.65388C14.0778 4.77397 12.5533 3.25 10.6734 3.25C8.7935 3.25 7.26953 4.77397 7.26953 6.65388L7.26953 14.9422M16.7314 10.0578V17.0192C16.7314 19.6319 14.6134 21.75 12.0006 21.75C9.38787 21.75 7.26981 19.6319 7.26981 17.0192V10.0578"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `plus` (stroke). */
export function PlusIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6 12.0002H18.0007M12.0002 6V18.0007"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `whatsapp` (outlined). */
export function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M19.074 4.89389C17.2091 3.02894 14.6689 2 12.0644 2C6.59814 2 2.12869 6.4373 2.12869 11.9035C2.12869 13.672 2.57885 15.3441 3.44702 16.8875L2.03223 22L7.33769 20.6495C8.78464 21.4212 10.4245 21.8714 12.0965 21.8714C17.5306 21.8392 21.9679 17.4019 21.9679 11.9035C21.9679 9.26688 20.939 6.791 19.074 4.89389ZM12.0322 20.1672C10.5853 20.1672 9.07403 19.7492 7.82001 18.9775L7.49846 18.7846L4.37949 19.5884L5.24766 16.5659L5.05473 16.2444C4.25088 14.926 3.80072 13.3826 3.80072 11.8392C3.80072 7.30547 7.46631 3.63987 12.0322 3.63987C14.2187 3.63987 16.2766 4.50804 17.82 6.05145C19.3634 7.59486 20.2316 9.68489 20.2316 11.9035C20.2959 16.5016 16.566 20.1672 12.0322 20.1672ZM16.566 13.9936C16.3088 13.865 15.119 13.254 14.8297 13.2219C14.6046 13.1254 14.4116 13.0932 14.283 13.3505C14.1544 13.6077 13.6399 14.1222 13.5113 14.3151C13.3827 14.4437 13.2541 14.508 12.9647 14.3473C12.7075 14.2187 11.9358 13.9936 10.9711 13.0932C10.2316 12.4502 9.71711 11.6463 9.62065 11.3569C9.49203 11.0997 9.5885 11.0032 9.74927 10.8424C9.87788 10.7138 10.0065 10.5852 10.103 10.3923C10.2316 10.2637 10.2316 10.135 10.3602 9.97428C10.4888 9.84566 10.3924 9.65274 10.328 9.52412C10.2316 9.3955 9.78142 8.17364 9.55634 7.65917C9.36342 7.1447 9.13834 7.24116 9.00972 7.24116C8.8811 7.24116 8.68817 7.24116 8.55956 7.24116C8.43094 7.24116 8.1094 7.27331 7.91647 7.5627C7.69139 7.81994 7.0483 8.43087 7.0483 9.65273C7.0483 10.8746 7.91647 12 8.07724 12.2251C8.20586 12.3537 9.84573 14.8939 12.2895 15.9871C12.8682 16.2444 13.3184 16.4051 13.7043 16.5338C14.283 16.7267 14.8297 16.6624 15.2477 16.6302C15.73 16.5981 16.6946 16.0514 16.9197 15.4405C17.1126 14.8939 17.1126 14.3473 17.0483 14.2508C16.984 14.1865 16.7911 14.09 16.566 13.9936Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Lineicons `menu-hamburger-1` (stroke). */
export function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 6L20 6M4 18L20 18M4 12L20 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `locked-2` (stroke). */
export function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7.5 9.87549H16.5M7.5 9.87549V7.25C7.5 4.76472 9.51472 2.75 12 2.75C14.4853 2.75 16.5 4.76472 16.5 7.25V9.87549M7.5 9.87549H5.5C4.67157 9.87549 4 10.5471 4 11.3755V17.25C4 19.4591 5.79086 21.25 8 21.25H16C18.2091 21.25 20 19.4591 20 17.25V11.3755C20 10.5471 19.3284 9.87549 18.5 9.87549H16.5M12 18.25C11.5858 18.25 11.25 17.9142 11.25 17.5V16C11.25 15.5858 11.5858 15.25 12 15.25C12.4142 15.25 12.75 15.5858 12.75 16V17.5C12.75 17.9142 12.4142 18.25 12 18.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `user-4` (stroke). */
export function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M19.5001 19.4395C19.5001 19.4395 19.626 12.9395 12.0001 12.9395C4.37429 12.9395 4.50013 19.4395 4.50013 19.4395M15.6618 6.34459C15.6618 8.32983 14.0525 9.93918 12.0672 9.93918C10.082 9.93918 8.47266 8.32983 8.47266 6.34459C8.47266 4.35935 10.082 2.75 12.0672 2.75C14.0525 2.75 15.6618 4.35935 15.6618 6.34459Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `envelope-1` (stroke). */
export function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21.25 6.23398V17.25C21.25 18.0784 20.5784 18.75 19.75 18.75H4.25C3.42157 18.75 2.75 18.0784 2.75 17.25V6.23398M3.73592 5.25H20.2644C20.8088 5.25 21.2501 5.69124 21.2501 6.23558C21.2502 6.5579 21.0926 6.85988 20.8282 7.04424L12.8583 12.6019C12.3428 12.9614 11.6579 12.9614 11.1424 12.6019L3.17217 7.04405C2.90794 6.8598 2.75043 6.55805 2.75032 6.23592C2.75014 5.69146 3.19146 5.25 3.73592 5.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `eye` (stroke). */
export function EyeIcon() {
  return (
    <svg viewBox="0 0 24 25" fill="none" aria-hidden="true">
      <path
        d="M2.95862 13.451C2.68046 12.8479 2.68046 12.1523 2.95862 11.5492C4.53779 8.1253 7.99237 5.75 11.9999 5.75C16.0075 5.75 19.4621 8.12531 21.0413 11.5492C21.3194 12.1523 21.3194 12.8479 21.0413 13.451C19.4621 16.8749 16.0075 19.2502 11.9999 19.2502C7.99237 19.2502 4.53779 16.8749 2.95862 13.451Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 12.5C15.625 14.502 14.002 16.125 12 16.125C9.99797 16.125 8.375 14.502 8.375 12.5C8.375 10.498 9.99797 8.875 12 8.875C14.002 8.875 15.625 10.498 15.625 12.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `eye-closed` (stroke). */
export function EyeClosedIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M2.74927 7.79883C2.74927 7.79883 6.26487 12.7909 11.9993 12.7909C17.7337 12.7909 21.2493 7.79883 21.2493 7.79883M11.9947 13.2V16.2M7.3495 12.3555L5.8495 14.9536M4.00126 9.83464L1.70312 11.763M22.2954 11.7639L19.9973 9.83555M18.149 14.9527L16.649 12.3546"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Lineicons `arrow-right` (stroke). */
export function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M20.0014 11.9966L4 11.9966M14.0054 6L20.0014 11.9998L14.0054 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `building` (stroke). */
export function BuildingIcon() {
  return (
    <svg viewBox="0 0 24 25" fill="none" aria-hidden="true">
      <path
        d="M4 22.147H20M9 17.897H10.5M13.5 17.897H15M9 12.897H10.5M13.5 12.897H15M9 7.89697H10.5M13.5 7.89697H15M18.75 22.147V5.14697C18.75 4.31855 18.0784 3.64697 17.25 3.64697H6.75C5.92157 3.64697 5.25 4.31855 5.25 5.14697V22.147H18.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `wrench` (stroke): after-sales. */
/** Lineicons "bar-chart-4" (stroke): reports. */
export function ReportIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21.25 18.75H4.25C3.42157 18.75 2.75 18.0784 2.75 17.25V5.25M8.25 15.7501H5.75V12.2773C5.75 11.587 6.30964 11.0273 7 11.0273C7.69036 11.0273 8.25 11.587 8.25 12.2773V15.7501ZM13.75 15.7501H11.25V6.5C11.25 5.80964 11.8096 5.25 12.5 5.25C13.1904 5.25 13.75 5.80964 13.75 6.5V15.7501ZM16.75 15.7501V10.0586C16.75 9.36824 17.3096 8.80859 18 8.80859C18.6904 8.80859 19.25 9.36824 19.25 10.0586V15.7501H16.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons "calendar-days" (stroke): agenda. */
export function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8 2.75V4.5M16 2.75V4.5M4 9H20M5.5 20.5H18.5C19.3284 20.5 20 19.8284 20 19V6C20 5.17157 19.3284 4.5 18.5 4.5H5.5C4.67157 4.5 4 5.17157 4 6V19C4 19.8284 4.67157 20.5 5.5 20.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.98438 12.75H7.99437M7.98438 16.75H7.99437M11.9941 12.75H12.0041M11.9941 16.75H12.0041M16.0039 12.75H16.0139M16.0039 16.75H16.0139"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons Pro "history-user" (stroke): auditoría. */
export function HistoryUserIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M3.36328 6.80786L4.14 9.7066L4.30983 9.6611M5.52486 16.7001C6.56013 18.1263 8.03731 19.1708 9.72705 19.6713C9.81737 19.6981 9.90802 19.7232 9.99897 19.7467M4.30983 9.6611C4.35969 9.51692 4.46961 9.24589 4.68147 8.76643C5.39378 7.15448 6.61837 5.82281 8.16511 4.97821C9.71185 4.13361 11.4942 3.82333 13.2353 4.09555C14.9765 4.36778 16.5791 5.20727 17.7942 6.48368C18.4927 7.21736 19.0406 8.0718 19.4157 8.99857M4.30983 9.6611L7.03874 8.92989M18.125 13.75C18.125 14.5784 17.4534 15.25 16.625 15.25C15.7966 15.25 15.125 14.5784 15.125 13.75C15.125 12.9216 15.7966 12.25 16.625 12.25C17.4534 12.25 18.125 12.9216 18.125 13.75ZM20.2564 21H12.9934V19.75C12.9934 18.6454 13.8888 17.75 14.9934 17.75H18.2564C19.361 17.75 20.2564 18.6454 20.2564 19.75V21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons Pro "file-invoice" (stroke): quotes. */
export function QuoteIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M15.75 9.25H14.25M15.75 12.25H11.25M5.38427 9.00073C5.45795 8.8385 5.56064 8.68917 5.68901 8.56072L11.0567 3.18967C11.1854 3.06093 11.335 2.95799 11.4976 2.88417M5.38427 9.00073H10.0009C10.8297 9.00073 11.5015 8.32851 11.5009 7.49966L11.4976 2.88417M5.38427 9.00073C5.29661 9.19374 5.25 9.40499 5.25 9.62105V19.75C5.25 20.5784 5.92157 21.25 6.75 21.25H17.25C18.0784 21.25 18.75 20.5784 18.75 19.75V4.25C18.75 3.42157 18.0784 2.75 17.25 2.75H12.1177C11.9017 2.75 11.6905 2.79658 11.4976 2.88417M8.25 15.25H15.75V18.25H8.25V15.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function WrenchIcon() {
  return (
    <svg viewBox="0 0 25 24" fill="none" aria-hidden="true">
      <path
        d="M8.0625 6.86389C8.0625 5.00334 9.20737 3.41019 10.8311 2.75049V5.93613C10.8311 6.76456 11.5026 7.43613 12.3311 7.43613H12.6711C13.4995 7.43613 14.1711 6.76456 14.1711 5.93614V2.75082C15.7943 3.41073 16.9388 5.00366 16.9388 6.86389C16.9388 8.7245 15.7939 10.3177 14.1701 10.9774V19.7525C14.1701 20.5809 13.4985 21.2525 12.6701 21.2525H12.3301C11.5017 21.2525 10.8301 20.5809 10.8301 19.7525V10.9769C9.20691 10.317 8.0625 8.72407 8.0625 6.86389Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `sun-1` (stroke): light mode. */
export function SunIcon() {
  return (
    <svg viewBox="0 0 24 25" fill="none" aria-hidden="true">
      <path
        d="M12 3.25V4.75M18.541 5.96094L17.4804 7.0216M21.25 12.5H19.75M18.541 19.0391L17.4804 17.9784M12 20.25V21.75M6.51953 17.9844L5.45887 19.045M4.25 12.5H2.75M6.51953 7.01562L5.45887 5.95496M7.25 12.5C7.25 15.1234 9.37665 17.25 12 17.25C14.6234 17.25 16.75 15.1234 16.75 12.5C16.75 9.87665 14.6234 7.75 12 7.75C9.37665 7.75 7.25 9.87665 7.25 12.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `moon-half-right-5` (stroke): dark mode. */
export function MoonIcon() {
  return (
    <svg viewBox="0 0 24 25" fill="none" aria-hidden="true">
      <path
        d="M16.5038 9.0019C16.5038 13.4213 12.9213 17.0039 8.5019 17.0039C6.39766 17.0039 4.48312 16.1916 3.05469 14.8636C4.09922 18.8272 7.70826 21.7499 11.9999 21.7499C17.1086 21.7499 21.2499 17.6086 21.2499 12.4999C21.2499 8.20826 18.3272 4.59922 14.3636 3.55469C15.6916 4.98312 16.5038 6.89766 16.5038 9.0019Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lineicons `bell-1` (stroke): notifications. */
export function BellIcon() {
  return (
    <svg viewBox="0 0 25 25" fill="none" aria-hidden="true">
      <path
        d="M12.833 3.25098V4.75098M12.833 4.75098C16.5609 4.75098 19.583 7.77305 19.583 11.501V14.6168C19.583 14.7055 19.5989 14.7935 19.6301 14.8766L20.3229 16.7243C20.6907 17.7049 19.9658 18.751 18.9184 18.751H15.1448M12.833 4.75098C9.10503 4.75098 6.08295 7.77305 6.08295 11.501V14.6168C6.08295 14.7055 6.06699 14.7935 6.03584 14.8766L5.34296 16.7243C4.97522 17.7049 5.70014 18.751 6.74745 18.751H10.5175M10.5175 18.751V19.437C10.5175 20.7142 11.5534 21.7495 12.8312 21.7495C14.1089 21.7495 15.1448 20.7142 15.1448 19.437V18.751M10.5175 18.751H15.1448"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
